import { Component, OnInit } from '@angular/core';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';

@Component({
  selector: 'app-rpv-precatorio',
  templateUrl: './rpv-precatorio.component.html'
})
export class RpvPrecatorioComponent implements OnInit {
  lstOrgaosJudiciario: IdDescricao[];

  constructor(
    private consultasService: ConsultasService
  ) 
  { }

  ngOnInit(): void {
    this.consultasService.consultar('ORGAODOJUDICIARIO').subscribe(data => this.lstOrgaosJudiciario = data);
  }

}
